import { render, staticRenderFns } from "./PlaneDiagram.vue?vue&type=template&id=880d8c3a&"
import script from "./PlaneDiagram.vue?vue&type=script&lang=js&"
export * from "./PlaneDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports